import React, { useEffect, useState, useContext } from "react";
import { Toast } from "./../UI/toast/Toast";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import PageHeader from "../common/PageHeader";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams } from "react-router";
import {
  addItemDebtToPay,
  markAsPaidDebtToPay,
  DebtToPayDetails,
} from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import CreateDebtToPayForm from "./CreateDebtToPayForm";
import { fetchProviders } from "../../helpers/api/provider";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import FalconCardHeader from "../common/FalconCardHeader";
import ButtonIcon from "../common/ButtonIcon";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Logo from "../navbar/Logo";
import NumberFormat from "react-number-format";
import { useForm } from "react-hook-form";
import Lightbox from "react-image-lightbox";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import SupportLink from "../root/support/components/SupportLink";
import Avatar from "../common/Avatar";
import Bs from "../../assets/img/icons/Bolivares Logo.png";
import moment from "moment";
import { CurrencyContext } from "../../context/Context";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const EditDebtToPay = ({ setRedirectUrl, setRedirect }) => {
  const moduleBase = useModuleBase();
  const { id, debtToPayId } = useParams();
  const { condominium, address } = useSelector((state) => state.condominium);
  const { role, token } = useSelector((state) => state.auth.user);
  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  const activeExchangeRate = Number(curr?.value ?? 0);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
  });
  // eslint-disable-next-line
  const [imagePreview, setImagePreview] = useState(null);
  const [payment_proof, setPayment_proof] = useState(null);
  const [images, setImages] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [debttopay, setDebttopay] = useState(null);
  const [total, setTotal] = useState(0);
  const [isAdd, setIsAdd] = useState(false);
  const [collapseOne, collapseOneOpen] = useState(false);
  const [params] = useState({
    condominiumId: id,
  });

  const {
    data,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchProviders, params);

  useEffect(() => {
    let isMounted = true;
    if (debtToPayId) {
      const findOne = async () => {
        try {
          const { data } = await DebtToPayDetails(debtToPayId);
          isMounted && setDebttopay(data);
          isMounted && setTotal(data.reduce((a, { amount }) => a + amount, 0));
          data.map(
            ({ voucher }) =>
              isMounted &&
              setImages((prev) => [
                ...prev,
                `${
                  import.meta.env.VITE_URL
                }/view/image/${token}?path=${voucher}&size=large`,
              ])
          );
        } catch (error) {
          handleErrorMessage(error);
        }
      };
      findOne();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [debtToPayId]);

  useEffect(() => {
    let isMounted = true;
    if (debttopay) {
      if (debttopay[0].voucher) {
        isMounted &&
          setImagePreview(
            `${import.meta.env.VITE_URL}/view/image/${token}?path=${
              debttopay[0].voucher
            }&size=large`
          );
      }
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [debttopay]);

  const add = async (values) => {
    const { amount, voucher, details } = values;

    try {
      let formData = new FormData();
      formData.append("provider", debttopay[0].provider.id);
      formData.append("details", details);
      formData.append("amount", amount);
      if (activeExchangeRate) formData.append("rate", activeExchangeRate);
      if (voucher) {
        formData.append("voucher", voucher);
      }
      const { code } = await addItemDebtToPay(debtToPayId, formData);

      if (code === SUCCESS_RESPONSE.SUCCESFUL) {
        setRedirectUrl(`/dashboard/${moduleBase}/${id}/topay`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Factura adicional agregada exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const markaspaid = async (values) => {
    const { payment_proof } = values;
    try {
      let formData = new FormData();
      if (payment_proof) {
        formData.append("payment_proof", payment_proof);
      }
      if (activeExchangeRate) formData.append("rate", activeExchangeRate);
      const { code } = await markAsPaidDebtToPay(debtToPayId, formData);

      if (code === SUCCESS_RESPONSE.SUCCESFUL) {
        setRedirectUrl(`/dashboard/${moduleBase}/${id}/topay`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Marcada como pagada exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const getDate = (date) => {
    var d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  const printDocument = () => {
    const input = document.getElementById("ToPay");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 0, 0);
      // pdf.output('dataurlnewwindow');
      pdf.save("download.pdf");
    });
  };

  return (
    <>
      <PageHeader
        title="Cuenta por pagar"
        titleTag="h2"
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      {debttopay && (
        <>
          <Card className="mb-3">
            <CardBody>
              <Row className="justify-content-between align-items-center">
                <Col md>
                  <h5 className="mb-2 mb-md-0">
                    Cuenta por pagar #{debtToPayId}
                  </h5>
                </Col>
                <Col xs="auto">
                  <ButtonIcon
                    color="falcon-default"
                    size="sm"
                    icon="arrow-down"
                    onClick={printDocument}
                    className="mr-2 mb-2 mb-sm-0"
                  >
                    Descargar (.pdf)
                  </ButtonIcon>
                  <ButtonIcon
                    color="falcon-default"
                    size="sm"
                    icon="print"
                    disabled
                    className="mr-2 mb-2 mb-sm-0"
                  >
                    Imprimir
                  </ButtonIcon>
                  {role === "manager" && !debttopay[0].paymented_at && (
                    <ButtonIcon
                      color="falcon-success"
                      size="sm"
                      icon="dollar-sign"
                      className="mb-2 mb-sm-0"
                      onClick={() => collapseOneOpen(!collapseOne)}
                    >
                      Marcar como pagada
                    </ButtonIcon>
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card className="mb-3" id="ToPay">
            <CardBody>
              <Row className="align-items-center text-center mb-3">
                <Col sm={6} className="text-sm-left">
                  <div className="text-sm-left col-sm-6">
                    <Logo width={150} />
                  </div>
                </Col>
                <Col className="text-sm-right mt-3 mt-sm-0">
                  <h2 className="mb-3">Pago a proveedor</h2>
                  <h5>{debttopay[0]?.provider.name}</h5>
                  <p className="fs--1 mb-0">
                    {debttopay[0].provider.address
                      ? debttopay[0].provider.address
                      : debttopay[0].provider.description}
                  </p>
                </Col>
                <Col xs={12}>
                  <hr />
                </Col>
              </Row>
              <Row className="justify-content-between align-items-center">
                <Col>
                  <h6 className="text-500">Factura para</h6>
                  <h5>{condominium}</h5>
                  <p className="fs--1">{address}</p>
                  <p className="fs--1">
                    <a href={`mailto:`}>{}</a>
                    <br />
                    <a href={`tel:`}>{}</a>
                  </p>
                </Col>
                <Col sm="auto" className="ml-auto">
                  <div className="table-responsive">
                    <Table size="sm" borderless className="fs--1">
                      <tbody>
                        <tr>
                          <th className="text-sm-right">
                            Cuenta para pagar Nro:
                          </th>
                          <td>{debtToPayId}</td>
                        </tr>
                        <tr>
                          <th className="text-sm-right">Fecha de cuenta:</th>
                          <td>
                            {moment(debttopay[0].created_at).format(
                              "DD-MM-YYYY"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th className="text-sm-right">Fecha de pago:</th>
                          <td>
                            {debttopay[0].paymented_at
                              ? moment(debttopay[0].paymented_at).format(
                                  "DD-MM-YYYY"
                                )
                              : "No cancelada"}
                          </td>
                        </tr>
                        <tr className="alert-success font-weight-bold">
                          <th className="text-sm-right">Monto:</th>
                          <td>
                            <NumberFormat
                              displayType="text"
                              prefix={`${baseCurrency.symbol} `}
                              allowedDecimalSeparators={true}
                              fixedDecimalScale
                              decimalScale={2}
                              thousandSeparator={true}
                              value={total}
                            />
                          </td>
                        </tr>
                        <tr className="text-sm-right">
                          <th></th>
                          <td>
                            <Avatar src={Bs} id="Bs-exchange" />
                            <UncontrolledTooltip
                              placement="left"
                              target="Bs-exchange"
                            >
                              <b>
                                <NumberFormat
                                  value={total * 4500000}
                                  thousandSeparator
                                  decimalScale={2}
                                  fixedDecimalScale
                                  displayType="text"
                                  prefix="Bs. "
                                />
                              </b>
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
              <div className="table-responsive mt-4 fs--1">
                <Table striped className="border-bottom">
                  <thead>
                    <tr /* className="bg-primary text-white" */>
                      <th className="border-0">Descripción</th>
                      <th className="border-0 text-center">Factura</th>
                      <th className="border-0 text-right">Estado</th>
                      <th className="border-0 text-right">Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    {debttopay.map((val, i) => (
                      <tr key={i}>
                        <td className="align-middle">
                          <h6 className="mb-0 text-nowrap">{val.details}</h6>
                          <p className="mb-0">{val.provider.name}</p>
                        </td>
                        <td className="align-middle text-center">
                          {val.voucher ? (
                            <Button
                              color="link"
                              size="sm"
                              onClick={() => {
                                setIsOpen(true);
                                setIndex(i);
                              }}
                            >
                              Ver Factura
                            </Button>
                          ) : (
                            <>No agregada</>
                          )}
                          {isOpen && (
                            <Lightbox
                              reactModalStyle={{ zIndex: 1250 }}
                              mainSrc={images[index]}
                              nextSrc={images[(index + 1) % images.length]}
                              prevSrc={
                                images[
                                  (index + images.length - 1) % images.length
                                ]
                              }
                              onCloseRequest={() => setIsOpen(false)}
                              onMovePrevRequest={() =>
                                setIndex(
                                  (index + images.length - 1) % images.length
                                )
                              }
                              onMoveNextRequest={() =>
                                setIndex((index + 1) % images.length)
                              }
                            />
                          )}
                        </td>
                        <td className="align-middle text-right">
                          {val.paymented_at
                            ? `Cancelada el ${getDate(val.paymented_at)}`
                            : "No cancelada"}
                        </td>
                        <td className="align-middle text-right">
                          <NumberFormat
                            className="text-right"
                            displayType="text"
                            allowedDecimalSeparators={true}
                            thousandSeparator={true}
                            prefix={`${baseCurrency.symbol} `}
                            fixedDecimalScale
                            decimalScale={2}
                            value={val.amount}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              <Row noGutters className="justify-content-end">
                <Col xs="auto">
                  <Table size="sm" borderless className="fs--1 text-right">
                    <tbody>
                      <tr className="border-top">
                        <th className="text-900">Total:</th>
                        <td className="font-weight-semi-bold">
                          <NumberFormat
                            className="text-right"
                            displayType="text"
                            allowedDecimalSeparators={true}
                            thousandSeparator={true}
                            fixedDecimalScale
                            decimalScale={2}
                            prefix={`${baseCurrency.symbol} `}
                            value={total}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </CardBody>
            <Modal isOpen={collapseOne} data-testid="modal">
              <ModalHeader>Confirmación</ModalHeader>
              <ModalBody>
                <Col
                  data-testid="form"
                  tag={Form}
                  className="bg-light"
                  onSubmit={handleSubmit(markaspaid)}
                >
                  <Row form className="py-2">
                    <Label>
                      Está apunto de marcar como pagada esta cuenta por pagar
                    </Label>
                  </Row>
                  {payment_proof && (
                    <Row form>
                      <Col
                        style={{
                          backgroundImage: `url(${payment_proof})`,
                          backgroundPosition: "center",
                          backgroundSize: "contain",
                          height: "400px",
                          width: "100%",
                          maxHeight: "400px",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></Col>
                    </Row>
                  )}
                  <Row form>
                    <Col tag={FormGroup}>
                      <Label>Prueba de pago</Label>
                      <Input
                        type="file"
                        name="payment_proof"
                        id="payment_proof"
                        accept="image/png, image/jpeg"
                        onChange={(event) => {
                          setPayment_proof(
                            URL.createObjectURL(event.target.files[0])
                          );
                          register("payment_proof");
                          setValue("payment_proof", event.target.files[0]);
                        }}
                        placeholder="Prueba de pago"
                      />
                    </Col>
                  </Row>
                  <Row form className="justify-content-end">
                    <Button
                      className="mr-2"
                      onClick={() => collapseOneOpen(!collapseOne)}
                    >
                      Cancelar
                    </Button>
                    <Button
                      data-testid="submit-button"
                      color="primary"
                      disabled={Object.keys(errors).length > 0}
                      type="submit"
                    >
                      Sí, marcar como pagada
                    </Button>
                  </Row>
                </Col>
              </ModalBody>
            </Modal>
          </Card>
          {role === "manager" && !debttopay[0].paymented_at && (
            <Card className="mb-3">
              <FalconCardHeader
                title="Facturas adicionales"
                children={
                  <ButtonIcon
                    color="falcon-default"
                    icon={faPlus}
                    onClick={() => setIsAdd(!isAdd)}
                  >
                    {!isAdd ? "Agregar" : "Ocultar"}
                  </ButtonIcon>
                }
              />
            </Card>
          )}
        </>
      )}
      {isAdd && (
        <>
          <CreateDebtToPayForm
            handleSubmitData={add}
            handler={{ nextPage, previousPage, perPage, goToPage, meta }}
            providers={data}
            debttopayId={debtToPayId}
          />
        </>
      )}
    </>
  );
};

export default withRedirect(EditDebtToPay);
